export default __webpack_public_path__ + "dd2cd4b2d4c3e43083dadf680d3484a4.png";